import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-plus",
  "use": "icon-plus-usage",
  "viewBox": "0 0 32 33",
  "content": "<symbol viewBox=\"0 0 32 33\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-plus\"><path d=\"M2 16.5L30 16.5\" stroke=\"#595FE5\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path d=\"M16 30.5L16 2.5\" stroke=\"#595FE5\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol